import React from 'react';
import { Container, Box } from '@chakra-ui/react';
import LoginForm from '../components/auth/LoginForm';

const LoginPage: React.FC = () => {
  return (
    <Container maxW="container.sm" py={{ base: 6, md: 10 }} px={{ base: 4, md: 6 }}>
      <Box>
        <LoginForm />
      </Box>
    </Container>
  );
};

export default LoginPage; 